
<p-card>
  <div class="offer-page-header">Offer Dashboard</div>
    <div *ngIf="!loading" class="record-counter">
      {{totalRecords}} record(s) found
      <span class="filter-icon-container" (click)="showSidebarFilter()"><i class="fas fa-filter"></i></span>
    </div>
 
    <p-table #offerTable [value]="offers"
      autoLayout="true" 
      [paginator]="true" 
      [loading]="loading" 
      [rows]="10"
      [totalRecords]="totalRecords" 
      dataKey="OfferId"
      [expandedRowKeys]="expandedRows"
      rowExpandMode="multiple"
      (onLazyLoad)="loadNextSet($event)"
      [lazy]="true"
      [lazyLoadOnInit] = "false"
      styleClass="offer-table">

      <ng-template pTemplate="header">
        <tr>
          <th class="td-icons"></th>
          <th style="width: 15%">Loan #</th>
          <th style="width: 15%">&nbsp;Offer #</th>
          <th style="width: 8%">Offer Status</th>
          <th class="align-right-amount">Reserve Price ($)</th>
          <th class="align-right-amount">List Price ($)</th>
          <th class="align-right-amount">FMV ($)</th>
          <th class="align-right-amount">Offer Amount ($)</th>
          <th class="td-icons" width="3%">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr *ngIf="!loading && totalRecords === 0 && !loadDefault">
            <td [attr.colspan]="8" class="align-center">No records found</td> 
        </tr>
        <tr *ngIf="!loading && totalRecords === 0 && loadDefault">
          <td [attr.colspan]="8" class="align-center">No new offers found</td> 
      </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-rowIndex="OfferId">
        <tr>
          <td class="td-icons">
            <a href="#" [pRowToggler]="rowData" class="toggler-sign"> 
              <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
            </a>
          </td>
          <td style="width: 15%">{{rowData.Loan}}</td>
          <td style="width: 8%; font-weight: bold;"><div [class]="rowData.OfferColor">{{rowData.OfferNumber}}</div></td>
          <td style="width: 15%">{{rowData.OfferStatus}}</td>
          <td class="align-right-amount">{{rowData.ReservePrice}}</td>
          <td class="align-right-amount">{{rowData.ListPrice}}</td>
          <td class="align-right-amount">{{rowData.FMV}}</td>
          <td class="align-right-amount">{{rowData.OfferAmount}}</td>
          <td class="td-icons" *ngIf="!rowData.CanAccept && !rowData.CanReject && !rowData.CanCounter && !rowData.CanHighestAndBest">
            <i class="fas fa-bolt actionItemsdisabled"></i>
            <i class="fas fa-chevron-down actionItemsdisabled" pTooltip="{{rowData.HoverInfo}}"></i>
          </td>
          <td class="td-icons" *ngIf="rowData.CanAccept || rowData.CanReject || rowData.CanCounter || rowData.CanHighestAndBest">
            <i class="fas fa-bolt bolt"></i>
            <i class="fas fa-chevron-down actionItems" (click)="actionMenu.toggle($event)" pTooltip="{{rowData.HoverInfo}}"></i>
            <!-- Lightning Action Menu -->
            <p-menu #actionMenu 
              appendTo="body" 
              [showTransitionOptions]="'0ms'" 
              [hideTransitionOptions]="'0ms'" 
              [popup]="true" 
              [model]="getActionItems(rowData)"
              styleClass="action-menu">
          </p-menu>
          </td>
        </tr>      
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-rowData>
        <tr>
          <td colspan="5">
            <div class="column-align">
              <div class="ui-g-6 align-right-label sub-label-left">
                  Auction Cycle :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.AuctionCycle}}
                </div>
            </div>
            <div class="column-align">
                <div class="ui-g-6 align-right-label sub-label-left">
                    Total Bids (#) :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.TotalBids}}
                </div>
            </div>
            <div class="column-align">
                <div class="ui-g-6 align-right-label sub-label-left">
                    Watches (#) :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.Watches}}
                </div>
            </div>
            <div class="column-align">
                <div class="ui-g-6 align-right-label sub-label-left">
                    Listing Type :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.ListingType}}
                </div>
            </div>
            <div class="column-align">
              <div class="ui-g-6 align-right-label sub-label-left">
                  Third Party Offer ID :
              </div>
              <div class="ui-g-6 align-left no-top-padding">
                {{rowData.ThirdPartyOfferId}}
              </div>
            </div>
            <div class="column-align" *ngIf="rowData.Action && rowData.Action != ''">
              <div class="ui-g-6 align-right-label sub-label-left">&nbsp;</div>
              <div class="ui-g-6 align-left no-top-padding">&nbsp;</div>
            </div>
            <div class="column-align"  *ngIf="(!rowData.CanAccept && !rowData.CanReject && !rowData.CanCounter && !rowData.CanHighestAndBest) && (rowData.OfferStatus == 'Negotiating' && rowData.SellerOfferAmount && rowData.SellerOfferAmount != '')">
              <div class="ui-g-6 align-right-label sub-label-left">&nbsp;</div>
              <div class="ui-g-6 align-left no-top-padding">&nbsp;</div>
            </div>
          </td>
          <td colspan="4">
            <div class="column-align">
              <div class="ui-g-6 align-right-label sub-label-right">
                Offer Amount($) :
              </div>
              <div class="ui-g-6 align-left no-top-padding">
                {{rowData.OfferAmount}}
              </div>
            </div>
            <div class="column-align">
              <div class="ui-g-6 align-right-label sub-label-right">
                  Offer Date :
              </div>
              <div class="ui-g-6 align-left no-top-padding">
                {{rowData.OfferDate}}
              </div>
            </div>
            <div class="column-align">
                <div class="ui-g-6 align-right-label sub-label-right">
                    Financing Type :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.FinancingType}}
                </div>
            </div>
            <div class="column-align">
                <div class="ui-g-6 align-right-label sub-label-right">
                    Buyer First Name :
                </div>
                <div class="ui-g-6 align-left no-top-padding">
                  {{rowData.BuyerFirstName}}
                </div>
            </div>
            <div class="column-align">
              <div class="ui-g-6 align-right-label sub-label-right">
                  Buyer Last Name :
              </div>
              <div class="ui-g-6 align-left no-top-padding">
                {{rowData.BuyerLastName}}
              </div>
            </div>

            <div class="action-button-container" *ngIf="(!rowData.CanAccept && !rowData.CanReject && !rowData.CanCounter && !rowData.CanHighestAndBest) && (rowData.OfferStatus == 'NEGOTIATING' && rowData.SellerOfferAmount && rowData.SellerOfferAmount != '')">
              <span class="action-button">Seller Offer ($) :  
              </span>
              <span class="action-button">
                <input type="number" pInputText class="seller-offer" disabled="true" [value]="rowData.SellerOfferAmount">          
              </span>
            </div>

            <div class="action-button-container" *ngIf="rowData.Action && rowData.Action != ''">
              <div class="button-container-align" *ngIf="!rowData.Action || rowData.Action == ''">&nbsp;</div>

              <span *ngIf="rowData.Action==='Accept'" class="action-button">
                <button pButton [id]="'Accept-'+rowData.OfferId" [label]="rowData.Processing? 'Loading...':'Accept'" [disabled]="rowData.Processing" type="button" (click)="updateOffer(rowData, 'Accept')"></button>           
              </span>

              <span *ngIf="rowData.Action==='Reject'" class="action-button">
                <button pButton [id]="'Reject-'+rowData.OfferId" [label]="rowData.Processing? 'Loading...':'Reject'" [disabled]="rowData.Processing" type="button" (click)="updateOffer(rowData, 'Reject')"></button>           
              </span>

              <span *ngIf="rowData.Action==='Counter'" class="action-button">
                <span class="error-text" *ngIf="rowData.IsSellerAmountInValid">Please enter a valid amount&nbsp;</span>
                <input pInputText 
                  class="seller-offer" 
                  [name]="'SellerOfferAmount-'+rowData.OfferId" 
                  [id]="'SellerOfferAmount-'+rowData.OfferId" 
                  placeholder="Seller Offer ($)" 
                  (keyup)="enableCounterButton($event, rowData)">                
                <button pButton [id]="'Counter-'+rowData.OfferId" [label]="rowData.Processing? 'Loading...':'Counter'" [disabled]="rowData.Processing || !rowData.EnableCounter" type="button" (click)="updateOffer(rowData, 'Counter')"></button>                
              </span>

              <span *ngIf="rowData.Action==='HighestAndBest'" class="action-button">
                <button pButton [id]="'HighestAndBest-'+rowData.OfferId" [label]="rowData.Processing? 'Loading...':'H&B'" [disabled]="rowData.Processing" type="button" (click)="updateOffer(rowData, 'HighestAndBest')"></button>           
              </span>

              <span *ngIf="rowData.CancelAction" class="action-button">
                <button pButton [id]="'Cancel-'+rowData.OfferId" [label]="rowData.Processing? 'Loading...':'Cancel'" [disabled]="rowData.Processing" class="ui-button-secondary" type="button" (click)="cancelOfferUpdate(rowData)"></button>           
              </span>
            </div>
          </td>
        </tr>   
      </ng-template>    
    </p-table>
</p-card> 

<!--- ******* FILTER SIDEBAR ****** --->
<p-sidebar 
  [(visible)]="showFilterSideBar" 
  appendTo="body" 
  position="right" 
  styleClass="filter-sidebar"
  blockScroll="true">
    <div class="offer-filter-header">
      Filter Criteria
    </div>
    <form [formGroup]="sidebarFilterForm" (ngSubmit) = "filterOffers()"  class="offer-filter-form">
      <div class="loan-number-div">
        <input type="text" pInputText placeholder="Loan Number" formControlName="LoanNumber">
      </div>
      <div class="offer-status-sub-header">Offer Status</div>
      <p-table [value]="allOfferStatus" autoLayout="true">
        <tr>
          <td>
            <ng-template pTemplate="body" let-row>
              <div class="ui-g-6">
                <p-checkbox [formControl]="sidebarFilterForm.controls['FilterOfferStatus']" [value]="row.value" [label]="row.label" [inputId]="row.inputId" ></p-checkbox>
              </div>
            </ng-template>
          </td>          
        </tr>
      </p-table>
      <div class="ui-grid-col-12 div-offer-filter-buttons">      
        <button pButton type="button" label="{{loading ? 'Loading..' : 'Reset'}}" class="ui-button-secondary offer-filter-cancel" (click)="resetFilter()"></button>
        <button pButton type="submit" [disabled]="(!filterOfferStatus.value || filterOfferStatus.value == '') && (!loanNumber.value || loanNumber.value == '')" label="{{loading ? 'Loading..' : 'Apply'}}"></button>
      </div>
    </form>
</p-sidebar>